import { BILLING_CYCLE } from "@/common/constants";
import { buildAccountBaseService } from "@/common/service/base-paid";
import { VIEWS } from "@/views/bridge.vue";
import { loadSelectByPersist } from "@/common/service/plan-data-mapper";
import { flowTypes, pageConfig } from "@/common/service/page-config";
import PageLoader from "@/common/service/flow/page-loader";
import { addToCartByCategoryAndBillingCycle } from "@/common/service/flow/utils";
import store from '@/store/index';
import { updatePlansCheckout, UpdateTypes } from '@/common/service/checkout-utils';
import { getBasePlansFrom } from '@/common/product';
import Flow from "@/flows/flow";
import { getPlanTypeByCategory } from '@/common/service/parse';

const loadDefaultSelectByQuery = (planList) => {
  const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);
  if (!hasSelected) {
    const { category } = pageConfig.editConfig;
    addToCartByCategoryAndBillingCycle(planList, getPlanTypeByCategory(category), category, BILLING_CYCLE.MONTHLY, 1);
    return planList;
  }
}
const initShoppingCart = async (state) => {
  const { persist } = state;
  const { planMap, subscriptions, boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService();

  const loader = new PageLoader(planMap);
  loader.decorate('loadByPersist', loadSelectByPersist(persist));
  loader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery);
  const planList = await loader.dispatch();

  return {
    allPlanMap,
    boughtPlans,
    subscriptions,
    freeTrialPlans,
    planMapFlat: planList,
  }
};

const submit = async () => {
  const getters = store.getters;
  const { planType } = pageConfig.editConfig;
  const currentSelectedPlan = getters.getSelectedPlans.find(item => item.type === planType);
  const boughtPlans = getters.boughtPlans;
  const boughtBasePlan = getBasePlansFrom(boughtPlans)?.[0] || {};
  const actionType = UpdateTypes.DOWNGRADE_TO_ZONE_BASIC_PLUS;
  const planList = [{
    quantity: currentSelectedPlan.cartInfo.selected_number,
    planCode: currentSelectedPlan.plan_code,
    oldPlanCode: boughtBasePlan.plan_code,
  }];
  return updatePlansCheckout(planList, actionType);
};

const preCheck = () => { };
export default {
  [flowTypes.downgrade]: class extends Flow {
    view() { return VIEWS.COMPOUND }
    init() { return initShoppingCart(...arguments) }
    beforeSubmit() { return preCheck() }
    submit() { return submit() }
  },
};
